// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__mYlhC","boxTitle":"Qualiphy_boxTitle__3yiLu","box":"Qualiphy_box__iS00a","toggleWrap":"Qualiphy_toggleWrap__3LvzC"};